<template lang="pug">
aiq-select(v-model="selected"
           multiple
           collapse-tags
           clearable
           :placeholder="$t(`${I18N_PREFIX}.placeholder`)"
           :suffix-icon="Icon.CaretBottom"
           size="small"
           :reserve-keyword="false")
  aiq-option(v-for="opt in options"
             :key="opt.value"
             :label="opt.label"
             :value="opt.value")
</template>

<script>
import { SOURCE_TYPES } from './constants';

const I18N_PREFIX = 'metrics_tab.smart_assist_tab.source_type_filter';

export default {
  name: 'SourceTypeFilter',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      I18N_PREFIX,
    };
  },
  computed: {
    selected: {
      get() { return this.modelValue },
      set(value) { this.$emit('update:modelValue', value) },
    },
    options() {
      return SOURCE_TYPES.map(value => ({
        value,
        label: this.$t(`${I18N_PREFIX}.options.${value}`),
      }));
    },
  },
};
</script>
